
import { Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SignatureCanvas } from "./SignatureCanvas";
import { SignatureDownloader } from "./SignatureDownloader";
import type { SavedSignature } from "@/types/signatures";

interface SavedSignatureCardProps {
  signature: SavedSignature;
  onDelete: (id: string) => void;
  onDownload: (signature: SavedSignature, format: 'svg' | 'png') => void;
  canvasRef: (el: HTMLCanvasElement | null) => void;
}

export const SavedSignatureCard = ({
  signature,
  onDelete,
  onDownload,
  canvasRef
}: SavedSignatureCardProps) => {
  return (
    <div className="group relative bg-white rounded-[24px] aspect-square w-full">
      <div 
        className="relative w-full h-full"
        onContextMenu={(e) => e.preventDefault()}
      >
        <SignatureCanvas
          signature={signature}
          canvasRef={canvasRef}
        />
      </div>
      <div className="absolute top-2 left-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
        <SignatureDownloader
          signature={signature}
          onDownload={onDownload}
        />
      </div>
      <div className="absolute top-2 right-2 z-10 opacity-0 group-hover:opacity-100 transition-opacity">
        <Button
          variant="secondary"
          size="icon"
          onClick={() => onDelete(signature.id)}
          className="rounded-full"
        >
          <Trash2 className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};
